import gql from 'graphql-tag';
import get from 'lodash/get';

import { executeGqlQuery } from 'src/graphql/client';

const QUERY = gql`
  query HasProjects($customerId: ID!) {
    projects(customerId: $customerId, first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
`;

export const checkHasProjects = (customerId) =>
  executeGqlQuery({
    query: QUERY,
    variables: { customerId },
  }).then(({ data }) => {
    const count = get(data, 'projects.edges.length', 0);
    return count > 0;
  });
